import { render, staticRenderFns } from "./OilLicMenu.vue?vue&type=template&id=2f8e0a75&"
import script from "./OilLicMenu.vue?vue&type=script&lang=js&"
export * from "./OilLicMenu.vue?vue&type=script&lang=js&"
import style0 from "./OilLicMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports